var exports = {
  "sT": "xfd349460--8eb852--promo",
  "Kk": "xfd349460--8eb852--icon",
  "Sl": "xfd349460--8eb852--image",
  "h_": "xfd349460--8eb852--description",
  "VA": "xfd349460--8eb852--subtitle",
};

module.exports = exports;
